import React from "react";
import publicConfig from "config/public";
import Head from "next/head";
import { useRouter } from "next/router";

import useDomainCountryCode from "hooks/useDomainCountryCode";
import { shouldNoIndex } from "utils/shouldNoIndex";

interface Props {
  title?: string;
  description?: string;
  image?: string | boolean;
}

const {
  imgix: { publicUrl },
} = publicConfig;

export const ProductCategoryMetaTags: React.FC<Props> = ({
  title,
  description,
  image,
}) => {
  const { asPath } = useRouter();
  if (!description) {
    description =
      "Shop the top THC, CBD, Delta 8 products online from Leafly. Browse a variety of cannabis products like flower, edibles, growing kits, seeds, & more.";
  }
  if (!title) {
    title = "THC & CBD Products Online by the Best Brands | Leafly";
  }
  if (!image) {
    image = `${publicUrl}/consumer-web/products/products-brands-shortC.jpg`;
  }
  image = `${image}?auto=compress&fit=fill&fill=solid&w=1200&h=630&fm=jpg`;

  const countryTag = useDomainCountryCode() === "CA" ? "en-ca" : "en-us";
  const titleTag = title
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-") // spaces to '-'
    .replace(/[^a-z\d-]/g, ""); // drop all chars not letters numbers or '-'

  return (
    <Head>
      <title>{title}</title>
      <meta name="robots" content={shouldNoIndex(asPath) ? "noindex" : ""} />
      <meta name="description" content={description} />
      <meta name="twitter:card" content="app" />
      <meta name="twitter:site" content="@Leafly" />
      <meta name="twitter:app:country" content="US" />
      <meta name="twitter:app:id:iphone" content="416456429" />
      <meta name="twitter:app:id:ipad" content="416456429" />
      <meta name="twitter:app:id:googleplay" content="leafly.android" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="description" content={description} />
      <meta name="og:description" content={description} />
      <meta name="og:image" content={image} />
      <meta name="og:site_name" content="Leafly" />
      <meta name="og:title" content={title} />
      <meta name="fb:app_id" content="210495295724612" />
      <meta name="sailthru.description" content={description} />
      <meta name="sailthru.tags" content={`${countryTag},${titleTag}`} />
      <meta name="sailthru.title" content={title} />
    </Head>
  );
};
